import { render, staticRenderFns } from "./AllUserCases.vue?vue&type=template&id=13372082&scoped=true&"
import script from "./AllUserCases.vue?vue&type=script&lang=js&"
export * from "./AllUserCases.vue?vue&type=script&lang=js&"
import style0 from "./AllUserCases.vue?vue&type=style&index=0&id=13372082&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13372082",
  null
  
)

export default component.exports